import { useEffect } from 'react';
import {
  CONTENTSQUARE_SCRIPTS,
  ROLES_FOR_CONTENTSQUARE_TRACKING
} from '../../../constants/global-constants';
import { getEnv } from '../../../../config/env-config';

const env = getEnv();

export default function useContentSquare(userRole) {
  useEffect(() => {
    // Tracking only specific roles
    if (!ROLES_FOR_CONTENTSQUARE_TRACKING.includes(userRole)) {
      return;
    }

    const currentHost = window.location.hostname;
    const scriptUrl = CONTENTSQUARE_SCRIPTS[env];

    if (!scriptUrl) {
      console.warn(`[ContentSquare] No matching script for host: ${currentHost}`);
      return;
    }

    // Preventing duplicate injection
    if (document.getElementById('contentsquare-script')) {
      return;
    }

    // Injecting script dynamically
    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    script.id = 'contentsquare-script';
    document.head.appendChild(script);

    console.log(`[ContentSquare] Script loaded for ${currentHost}:`);

    // Cleaning-up (remove script on unmount)
    return () => {
      const existing = document.getElementById('contentsquare-script');

      if (existing) {
        existing.remove();
        console.log('[ContentSquare] Script removed on cleanup.');
      }
    };
  }, [userRole]);
}
